export const ADDPAYMENT_RESET_STATE = 'ADDPAYMENT_RESET_STATE';
export const ADDPAYMENT_CURRENT_ITEM = 'ADDPAYMENT_CURRENT_ITEM';

export const ADDPAYMENT_REQUEST_LOADING = 'ADDPAYMENT_REQUEST_LOADING';
export const ADDPAYMENT_REQUEST_SUCCESS = 'ADDPAYMENT_REQUEST_SUCCESS';
export const ADDPAYMENT_REQUEST_FAILED = 'ADDPAYMENT_REQUEST_FAILED';

export const ADDPAYMENT_CURRENT_ACTION = 'ADDPAYMENT_CURRENT_ACTION';
export const ADDPAYMENT_RESET_ACTION = 'ADDPAYMENT_RESET_ACTION';